import { Component, ElementRef, HostListener, Renderer2, ViewChild } from '@angular/core';
import { ModalController, ViewWillEnter } from '@ionic/angular';

import { ModalRoleEnum } from '../../enums/modal-role.enum';
import { VendasDetalheModel } from '../../models/vendas-detalhe.model';
import { HelpersUtil } from '../../utils/helpers.util';
import { KeyboardKeysEnum } from '../../enums/keyboard-keys.enum';
import { DialogStateUtil } from '../../utils/dialog-state.util';

@Component({
    selector: 'app-observacoes-produto',
    templateUrl: './observacoes-produto.component.html',
    styleUrls: ['./observacoes-produto.component.scss'],
})
export class ObservacoesProdutoComponent implements ViewWillEnter {
    // ModalProps
    readonly det: VendasDetalheModel;

    private obs: string = '';

    arrComplementosParaAdicionar: string[] = [];
    arrComplementosParaRemover: string[] = [];

    @ViewChild('inpt_adicionar', { static: false }) inptAdicionar: ElementRef;
    @ViewChild('inpt_remover', { static: false }) inptRemover: ElementRef;

    private get inptAdicionarValue() {
        return this.inptAdicionar.nativeElement.value;
    }

    private get inptRemoverValue() {
        return this.inptRemover.nativeElement.value;
    }

    constructor(
        private renderer: Renderer2,
        private modalCtrl: ModalController,
    ) { }

    ionViewWillEnter(): void {
        this.load();

        HelpersUtil.executeAfterDelay(() => this.renderer.selectRootElement(this.inptAdicionar.nativeElement).focus())
    }

    public addComplementoParaAdicionar(event: any, input: HTMLInputElement): void {
        event.preventDefault();
        event.stopPropagation();

        this.adicionar(input, this.arrComplementosParaAdicionar);
    }

    addComplementoParaRemover(input: HTMLInputElement): void {
        this.adicionar(input, this.arrComplementosParaRemover);
    }

    cancel(): void {
        this.modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);

        DialogStateUtil.dialogIsClosed();
    }

    confirm(): void {
        this.montarObs();

        const dataClose = new ObservacoesProdutoDataClose(this.obs);

        this.modalCtrl.dismiss(dataClose, ModalRoleEnum.CONFIRM);

        DialogStateUtil.dialogIsClosed();
    }

    limpar(): void {
        this.arrComplementosParaAdicionar = [];
        this.arrComplementosParaRemover = [];
    }

    remover(arr: string[], index: number): void {
        arr.splice(index, 1);
    }

    private adicionar(input: HTMLInputElement, arr: string[]): void {
        const valor = input.value.toUpperCase().trim();

        if (!valor) return;

        arr.push(valor);

        input.value = '';
        input.focus();
    }

    @HostListener('window:keydown', ['$event'])
    private async handleKeyboardEvent(event: KeyboardEvent): Promise<void> {
        switch (event.key) {
            case KeyboardKeysEnum.Escape:
                this.cancel();
                break;
            case KeyboardKeysEnum.F5:
                this.confirm();
                break;
        }
    }

    private load(): void {
        if (!this.det.obs) return;

        const arrObs = this.det.obs.split(',');

        (arrObs ?? []).forEach(complemento => {
            const contains = complemento.includes('C/ ');

            complemento = complemento
                .replace('C/', '')
                .replace('S/', '')
                .trim();

            contains ? this.arrComplementosParaAdicionar.push(complemento) : this.arrComplementosParaRemover.push(complemento);
        });
    }

    private montarObs(): void {
        if (this.inptAdicionarValue)
            this.arrComplementosParaAdicionar.push(this.inptAdicionarValue);

        if (this.inptRemoverValue)
            this.arrComplementosParaRemover.push(this.inptRemoverValue);

        const arrObs: string[] = [];

        this.arrComplementosParaAdicionar.forEach(complemento => arrObs.push(`C/ ${complemento}`));
        this.arrComplementosParaRemover.forEach(complemento => arrObs.push(`S/ ${complemento}`));

        this.obs = arrObs.join(', ');
    }
}

export class ObservacoesProdutoDataClose {
    constructor(public obs: string) { }
}
